import {
  VIEW_MODES,
  OVERLAY_COLORS,
  OVERLAY_OPACITY
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'
import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'
import {
  drawContours,
  getContourStyles
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/contours'

export const drawOverlay = (container, options) => {
  const { id, answer, image, scale, batches, config, width, height } = options
  const imageHeight = image?.original?.height
  const viewMode = VIEW_MODES.OVERLAY

  const svg = createSvgRoot(container, { id, viewMode, width, height, scale })

  const defs = svg.append('defs')
  defs.html(getSvgDefs(id, viewMode, { imagePath: image.original.path, imageWidth: width, imageHeight: height }))

  // the blend filter is emitted per view, so it is addressed by the view rather than by name
  const group = svg
    .append('g')
    .attr('id', `svg-${viewMode}-${id}-group`)
    .attr('filter', `url(#filter-${viewMode}-${id})`)

  group.append('rect').attr('fill', 'none').attr('width', width).attr('height', height)

  if (!answer?.heatmap?.contours || !answer?.heatmap?.levels) return null

  const { contours, levels } = answer.heatmap
  const { colors, opacityValues, isOnePinTypeFiltered } = getContourStyles(
    config,
    batches,
    OVERLAY_COLORS,
    OVERLAY_OPACITY
  )

  drawContours(group, {
    id,
    contours,
    levels,
    imageHeight,
    colors,
    opacityValues,
    isOnePinTypeFiltered
  })

  return null
}
